export const EMAIL_STORAGE_KEY = 'athwab:auth:magic-link-email';
export const REDIRECT_STORAGE_KEY = 'athwab:auth:redirect';
export const GOOGLE_REDIRECT_STORAGE_KEY = 'athwab:auth:google-redirect-started-at';

const GOOGLE_REDIRECT_TTL_MS = 15 * 60 * 1000;

const getStorage = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.localStorage;
};

export const sanitizeRedirect = (value?: string | null) => {
  if (!value) {
    return undefined;
  }

  return value.startsWith('/') ? value : undefined;
};

export const markGoogleRedirectPending = (startedAt = Date.now()) => {
  getStorage()?.setItem(GOOGLE_REDIRECT_STORAGE_KEY, String(startedAt));
};

export const clearGoogleRedirectPending = () => {
  getStorage()?.removeItem(GOOGLE_REDIRECT_STORAGE_KEY);
};

export const hasPendingGoogleRedirect = (now = Date.now()) => {
  const startedAt = getStorage()?.getItem(GOOGLE_REDIRECT_STORAGE_KEY);
  if (!startedAt) {
    return false;
  }

  const parsedStartedAt = Number.parseInt(startedAt, 10);
  if (!Number.isFinite(parsedStartedAt)) {
    clearGoogleRedirectPending();
    return false;
  }

  if (now - parsedStartedAt > GOOGLE_REDIRECT_TTL_MS) {
    clearGoogleRedirectPending();
    return false;
  }

  return true;
};
